import { ScheduleType } from "@pulse/pulse-rpcs/lib/email-cycle/scheduleType";
import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const ImmediateScheduleModel = types
  .model("ImmediateScheduleModel", {
    type: types.literal("IMMEDIATE_SCHEDULE"),
  })
  .views(() => ({
    get isEmptyValues(): boolean {
      return false;
    },

    get hasValidateError(): boolean {
      return false;
    },

    get rpcObject(): ScheduleType.Immediate {
      return new ScheduleType.Immediate();
    },
  }));

export const createImmediateScheduleModel = (
  immediateSchedule?: SnapshotIn<typeof ImmediateScheduleModel>,
): Instance<typeof ImmediateScheduleModel> =>
  ImmediateScheduleModel.create(
    immediateSchedule ?? {
      type: "IMMEDIATE_SCHEDULE",
    },
  );
